<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <MyForm ref="form" :form="form" :rules="rules" :labelWidth="labelWidth" :formGroups="[{ formCtrl }]"
      :viewMode="viewMode" @onChange="onChange" @onInput="onInput" @onSelect="onSelect">
    </MyForm>

    <div class="btns">
      <!-- <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn> -->
      <SubmitBtn @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">返 回</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";

export default {
  name: "FixdDtail",
  mixins: [detailMixin],
  data() {
    return {
      baseUrl: 'inspection',
      getDataUrl: 'detail',
      submitUrl: 'insert',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/inspect` },
        { name: "车辆年检", path: `/vehicle/inspect` },
        { name: "年检更新" },
      ],
      form: {
        license: null,
        vtype: null,
        inspection_at: null,
        cost: null,
        institution: null,
        next_inspection_at: null,
        updated_at: null,
      },
      rules: {
        inspection_at: [
          { required: true, message: "请选择年检时间", trigger: "blur" },
        ],
        cost: [
          { required: true, message: "请填写年检费用", trigger: "blur" },
        ],
        institution: [
          { required: true, message: "请填写年检机构", trigger: "blur" },
        ],
        next_inspection_at: [
          { required: true, message: "请选择下次年检时间", trigger: "blur" },
        ],
        updated_at: [
          { required: true, message: "请选择更新时间", trigger: "blur" },
        ],
      },
      formCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          // disabled: true,
          viewMode: true,
        },
        {
          label: "车辆类型",
          keyName: "vtype",
          err: "请填写车辆类型",
          type: "text",
          // disabled: true,
          viewMode: true,
          // options: []
        },
        {
          label: "年检时间",
          keyName: "inspection_at",
          err: "请选择时间",
          type: "date",
        },
        {
          label: "年检费用",
          keyName: "cost",
          err: "请填写年检费用",
          type: "number",
        },
        {
          label: "年检机构",
          keyName: "institution",
          err: "请填写年检机构",
          type: "text",
        },
        {
          label: "下次年检时间",
          keyName: "next_inspection_at",
          err: "请选择时间",
          type: "date",
          pickerOptions: {},
        },
        {
          label: "更新时间",
          keyName: "updated_at",
          err: "请选择时间",
          type: "date"
        },
        {
          label: "备注信息",
          keyName: "desc",
          err: "请填写内容",
          type: "textarea",
          rows: '3',
          className: 'block',
        },
      ],
      car_type: 1,
    };
  },
  methods: {
    onInput({ key, value }) {
      console.log(key, value)
      if (['institution'].includes(key) && value) {
        this.inputSearch(key, value)
      } else if (!value) {
        this.formCtrl.map(v => {
          if (v.keyName == 'institution') {
            v['options'] = []
          }
        })
        this.$forceUpdate()
      }
    },
    inputSearch(key, value) {
      // console.log(id, key, value)
      let url = `inspection/searchInstitution`;
      const params = {
        [key]: value,
      }
      // console.log(url, params)
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          this.formCtrl.map(v => {
            if (v.keyName == 'institution') {
              v['options'] = data.map(v => {
                return {
                  label: v,
                  value: v,
                  data: v,
                }
              })
            }
          })
          this.$forceUpdate()
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onSelect({ key, value }) {
      console.log(key, value)
      this.formCtrl.map(v => {
        if (v.keyName == 'institution') {
          v['options'] = []
        }
      })
      if (value) {
        this.$set(this.form, key, value)
      }
      this.$forceUpdate()
    },
    onChange({ key, value }) {
      // console.log(key, value)
      if (['inspection_at'].includes(key)) {
        // console.log('inspection_at--', (new Date(value)).getTime())
        // console.log('inspection_at--', Date.now())
        this.formCtrl.map(v => {
          if (v.keyName === 'next_inspection_at') {
            v.pickerOptions = {
              disabledDate(time) {
                return time.getTime() < (new Date(value)).getTime();
              },
            }
          }
        })
        this.$forceUpdate()
      }
      this.$set(this.form, key, value)
      // console.log({ ...this.form });
    },
    getData() {
      this.loading = true
      let url = `${this.baseUrl}/${this.getDataUrl}`;
      const params = {
        userid: this.user.id,
        id: this.id,
        car_type: this.car_type,
      }
      this.post(url, params, (res) => {
        const { msg, data } = res
        console.log(res)
        if (msg === 'success' && data) {
          console.log(data)
          this.form.license = data.license
          this.form.vtype = data.vtype
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    getKeys() {
      const formCtrl = [...this.formCtrl]
      const arr = formCtrl.map(v => v.keyName)
      arr.push('car_type')
      return arr
    },
  },
  created() {
    const { car_type } = this.$route.query
    if (car_type) {
      this.car_type = car_type
      this.form.car_type = car_type
    }
  },
  mounted() { },
};
</script>

<style lang="less" scoped>
.btns {
  margin: 40px 0 60px 180px;
}
</style>
